import { themeVars } from 'atomic/styles/theme.css'
import usePaymentOptions from 'hooks/usePaymentOptions'
import Image from 'next/image'
import React from 'react'

type PaymentMethodsProps = {
  showPoweredByStripe?: boolean
  poweredByStripeColor?: 'black' | 'white' | 'blurple'
  size: 's' | 'l'
}

const PaymentMethods: React.FC<PaymentMethodsProps> = ({ showPoweredByStripe = true, poweredByStripeColor = 'blurple', size }) => {
  const { paymentOptions } = usePaymentOptions()
  return (
    <>
      {paymentOptions?.map((option, index) => (
        <Image
          key={index}
          style={{ height: themeVars.spaces.l, width: 'auto', maxHeight: size === 's' ? 26 : 32 }}
          width="0"
          height="0"
          src={option?.image?.url}
          alt={option?.name}
          sizes={`(max-width: ${themeVars.breakpoints.tablet}) 100vw, 50vw`}
          fetchPriority="low"
          loading="lazy"
        />
      ))}
      {showPoweredByStripe && (
        <Image
          src={`/icons/PoweredByStripe_${poweredByStripeColor}.svg`}
          alt="Powered by Stripe"
          height={size === 's' ? 26 : 32}
          width={size === 's' ? 114 : 140}
        />
      )}
    </>
  )
}

export default PaymentMethods
